import { alpha, IconButton, type IconButtonProps } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';
import Tooltip from '@mui/material/Tooltip/Tooltip';
import React from 'react';
import { spacing } from '../Helper/ThemeHelper';

interface Props extends IconButtonProps {
  sticky: boolean;
  icon: React.ComponentType<SvgIconProps>;
  tooltipText?: string;
}

export class NavigationButton extends React.Component<Props> {
  public render(): React.JSX.Element {
    const { sticky, icon, tooltipText, sx, ...buttonProps } = this.props;
    const Icon = icon;

    const button = (
      <IconButton
        size={'large'}
        sx={{
          color: (theme) => theme.palette.header.contrastText,
          marginLeft: (theme) => spacing(theme),
          '&:hover': {
            backgroundColor: (theme) => alpha(theme.palette.header.contrastText, 0.12),
          },
          ...(sticky && {
            position: 'fixed',
            top: 0,
            right: (theme) => spacing(theme) * 3,
            zIndex: 1299,
            width: 'auto',
            height: 'auto',
            animationDuration: '500ms',
            animationTimingFunction: 'ease',
            animationName: '$headerSticky',
            '@keyframes headerSticky': {
              '0%': {
                top: -100,
              },
              '100%': {
                top: 0,
              },
            },
          }),
          ...sx,
        }}
        {...buttonProps}
      >
        <Icon />
      </IconButton>
    );

    if (!tooltipText) {
      return button;
    }

    return (
      <Tooltip title={tooltipText} placement={'bottom'} enterDelay={500} leaveDelay={200}>
        {button}
      </Tooltip>
    );
  }
}
